export class ControlTypeToNameBaseValueConverter {
    toView(value) {
        switch(value) {
            case 4: return 'TextBox';
            default: return 'TextBox';
        }
    }
}